import { render } from "./ProjectParticipationRestrictionWidget.vue?vue&type=template&id=356c20c4&ts=true"
import script from "./ProjectParticipationRestrictionWidget.ts?vue&type=script&lang=ts&external"
export * from "./ProjectParticipationRestrictionWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__